import { Component, Inject, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { map, startWith } from 'rxjs';
import { CourseTrackService } from '../course-track.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSelect } from '@angular/material/select';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-coursedialog',
  templateUrl: './coursedialog.component.html',
  styleUrls: ['./coursedialog.component.scss']
})
export class CoursedialogComponent {
  isInputDisabled = false;
  response: any;
  myGroup!: FormGroup;
  save: any;
  table: any;
  PENDING: any;
  data1: any;
  selectedCoachingType: any;
  Trackname: any;
  update: boolean = true;
  save1: boolean = true;
  data: any;
  dialogRef: any;
  options: any;
  response1: any;
  response2: any;

  groupName: any;
  className: any;
  medium: any;

  trackType: any;
  orientation: any;
  streamName: any;
  subStreamName: any;
  coachingType: any;

  classNames: any;
  mediums: any;
  group: any;
  groupname: any;
  orientationname: any;
  tpye: any;
  stream: any;
  substream: any;
  groupNames: any;
  dataTable: any;
  report: any;

  Class: any = new FormControl();
  Medium: any = new FormControl();
  Group: any = new FormControl();
  Orientation: any = new FormControl();
  Track: any = new FormControl();
  Strem: any = new FormControl();
  Substream: any = new FormControl();

  constructor(private course: CourseTrackService, private fb: FormBuilder, private renderer: Renderer2, @Inject(MAT_DIALOG_DATA) public data11: any, public dialog: MatDialog, private dialog1: NgDialogAnimationService, public dialogRef1: MatDialogRef<CoursedialogComponent>, public snackbar: MatSnackBar,private spinner: NgxSpinnerService) { }
  filterBy: string = 'PENDING';
  @ViewChild('inputField1') inputField1: any;
  @ViewChild('inputField2') inputField2: any;
  @ViewChild('inputField3') inputField3: any;
  @ViewChild('inputField4') inputField4: any;
  @ViewChild('inputField5') inputField5: any;
  @ViewChild('inputField6') inputField6: any;
  @ViewChild('inputField7') inputField7: any;
  @ViewChild('inputField8') inputField8: any;
  @ViewChild('inputField9') inputField9: any;
  @ViewChild('inputField10') inputField10: any;
  @ViewChild('inputField11') inputField11: any;
  @ViewChild('matSelect') matSelect: MatSelect;
  ngOnInit(): void {
    console.log("edit", this.data11)
    console.log('change', this.data1);

    this.myGroup = this.fb.group({
      Trackname: ["", Validators.required],
      TrackCode: ["", Validators.required],
      // Class: ["", Validators.required],
      // Medium: ["", Validators.required],
      // Group: ["", Validators.required],
      // Orientation: ["", Validators.required],
      // Track: ["", Validators.required],
      // Strem: ["", Validators.required],
      // Substream: ["", Validators.required],

      classname: ["", Validators.required],
      mediumname: ["", Validators.required],
      groupname: ["", Validators.required],
      Orientationname: ["", Validators.required],
      trackname: ["", Validators.required],
      streamname: ["", Validators.required],
      substreamname: ["", Validators.required],

      radio: ["", Validators.required],

      status: new FormControl('true'),
    });
    this.getcourse()

    // Call the getdata method here
    this.getdata(this.filterBy);

    this.edit()

  }
  private _filter(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.className.filter((option: any) => option.displayName.toLowerCase().includes(filterValue));
  }
  private _filter1(value: string): any[] {
    const filterValue1 = value.toLowerCase();
    return this.medium.filter((option: any) => option.medium.toLowerCase().includes(filterValue1));
  }
  private _filter2(value: string): any[] {
    const filterValue2 = value.toLowerCase();
    return this.groupname.filter((option: any) => option.groupName.toLowerCase().includes(filterValue2));
  }
  private _filter3(value: string): any[] {
    const filterValue3 = value.toLowerCase();
    return this.orientation.filter((option: any) => option.orientation.toLowerCase().includes(filterValue3));
  }
  private _filter4(value: string): any[] {
    const filterValue4 = value.toLowerCase();
    return this.trackType.filter((option: any) => option.trackType.toLowerCase().includes(filterValue4));
  }
  private _filter5(value: string): any[] {
    const filterValue5 = value.toLowerCase();
    return this.streamName.filter((option: any) => option.streamName.toLowerCase().includes(filterValue5));
  }
  private _filter6(value: string): any[] {
    const filterValue6 = value.toLowerCase();
    return this.subStreamName.filter((option: any) => option.subStreamName.toLowerCase().includes(filterValue6));
  }

  updata() {
    this.save1 = true;
    if (this.myGroup.valid) {
      // const class1=this.className.find((item:any) => item.displayName === this.myGroup.value.Class)
      const class1 = this.className.find((item: any) =>
        item.displayName === this.myGroup.value.classname || item.className === this.myGroup.value.classname
      );

      const Group1 = this.groupname.find((item: any) => item.groupName === this.myGroup.value.groupname);
      const Strem2 = this.streamName.find((item: any) => item.streamName === this.myGroup.value.streamname);
      const strem1 = this.subStreamName.find((item: any) => item.subStreamName === this.myGroup.value.substreamname)
      let playload = {
        "courseTrackId": this.data1?.courseTrackId ? this.data1?.courseTrackId : 0,
        "courseTrackName": this.myGroup.value.Trackname.toUpperCase(),
        "courseTrackCode": this.myGroup.value.TrackCode.toUpperCase(),
        "classId": class1.id,
        "medium": this.myGroup.value.mediumname,
        "groupId": Group1.groupId,
        "groupName": Group1.groupName,
        "trackType": this.myGroup.value.trackname,
        "orientation": this.myGroup.value.Orientationname,
        "streamId": Strem2.sreamId,
        "stream": Strem2.streamName,
        "subStreamId": strem1.subStreamId,
        "coachingType": this.myGroup.value.radio.toUpperCase()
      }


      if (confirm('do you want to save Course Track Details')) {
        this.course.getsave(playload).subscribe((res: any) => {
          this.save = res
          this.dialogRef1.close("save")
          // $('#example').DataTable().destroy();
          // this.getdata(this.filterBy);
          // this.getcourse()
          this.snackbar.open('Course Track Details Saved Successfully ', 'Close', {
            duration: 2000,
            verticalPosition: 'top',
            horizontalPosition: 'end',
          });
        })

        this.myGroup.reset()
        this.myGroup.patchValue({
          status: 'true'
        })

      }
    }
    else if (this.myGroup.value.Trackname == "") {
      window.alert("please Enter the coursetrackname")
      this.inputField1.nativeElement.focus();
      return
    }
    else if (this.myGroup.value.TrackCode == "") {
      window.alert("please Enter the coursetrackcode")
      this.inputField2.nativeElement.focus();
      return
    }
    else if (!this.myGroup.value.classname) {
      window.alert("please select the class")

      this.inputField3.nativeElement.focus();

      return
    }
    else if (this.myGroup.value.mediumname == "" || this.myGroup.value.mediumname == null) {
      window.alert("please select the Medium ")
      this.inputField4.nativeElement.focus();
      return
    }
    else if (this.myGroup.value.groupname == "" || this.myGroup.value.groupname == null) {
      window.alert("please select the groupName ")
      this.inputField5.nativeElement.focus();
      return
    }
    else if (this.myGroup.value.Orientationname == "" || this.myGroup.value.Orientationname == null) {
      window.alert("please select the Orientation")
      this.inputField6.nativeElement.focus();
      return
    }
    else if (this.myGroup.value.trackname == "" || this.myGroup.value.trackname == null) {
      window.alert("please select the  TrackType")
      this.inputField7.nativeElement.focus();
      return
    }
    else if (this.myGroup.value.streamname == "" || this.myGroup.value.streamname == null) {
      window.alert("please select the Strem")
      this.inputField8.nativeElement.focus();
      return
    }
    else if (this.myGroup.value.substreamname == "" || this.myGroup.value.substreamname == null) {
      window.alert("please select the Substream")
      this.inputField9.nativeElement.focus();
      return
    }
    else if (this.myGroup.value.radio == "" || this.myGroup.value.radio == null) {
      window.alert("please select the coachingType")
      this.inputField10.nativeElement.focus();
      return
    }
    this.save1 = true
    this.update = false;
    status
  }
  getdata(filterBy: any) {


  }

  filterCampus(enteredData: any) {
    this.response1 = this.options?.className.filter((item: any) => {
      return item.className.toLowerCase().indexOf(enteredData.toLowerCase()) > -1
    })

  }
  filterclass(enteredData1: any) {
    this.response2 = this.options?.medium.filter((item: any) => {
      return item.medium.toLowerCase().indexOf(enteredData1.toLowerCase()) > -1
    })
  }

  pending(filterParams: any) {
    this.spinner.show()
    this.course.gettable(filterParams).subscribe((res: any) => {
      this.table = res;
      this.spinner.hide()
      $('#example').DataTable().destroy();
      $(document).ready(() => {
        $('#example').DataTable({
          scrollX: true
        });
      });
    });
  }

  getcourse() {
    this.spinner.show()
    this.course.getcoursetrake().subscribe((res: any) => {
      this.className = res.className;
      this.medium = res.medium;
      this.groupname = res.groupNames;
      this.orientation = res.orientation
      this.trackType = res.trackType;
      this.streamName = res.stream;
      this.subStreamName = res.subStream;
      this.coachingType = res.coachingType
      this.spinner.hide()
      this.classNames = this.Class!.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value as string))
      );
      this.mediums = this.Medium!.valueChanges.pipe(
        startWith(''),
        map(value => this._filter1(value as string))
      );
      this.group = this.Group!.valueChanges.pipe(
        startWith(''),
        map(value => this._filter2(value as string))
      );
      this.orientationname = this.Orientation!.valueChanges.pipe(
        startWith(''),
        map(value => this._filter3(value as string))
      );
      this.tpye = this.Track!.valueChanges.pipe(
        startWith(''),
        map(value => this._filter4(value as string))
      );
      this.stream = this.Strem!.valueChanges.pipe(
        startWith(''),
        map(value => this._filter5(value as string))
      );
      this.substream = this.Substream!.valueChanges.pipe(
        startWith(''),
        map(value => this._filter6(value as string))
      );
    })
  }
  onOptionSelected() {
    this.isInputDisabled = true;
  }
  // close() {
  //   this.dialogRef1.close();
  // }
  edit() {
    this.myGroup.patchValue({
      Trackname: this.data11.courseTrackName.toUpperCase(),
      TrackCode: this.data11.courseTrackCode.toUpperCase(),
      classname: this.data11.displayname,
      mediumname: this.data11.medium,
      groupname: this.data11.groupName,
      Orientationname: this.data11.orientation,
      trackname: this.data11.trackType,
      streamname: this.data11.streamName,
      substreamname: this.data11.subStreamName,
      radio: this.data11.coachingType.toLowerCase(),
      status: "true"
    });

  }
  Classinput(select: MatSelect){
    this.Class.setValue("");
    if (this.matSelect) {
      this.matSelect.open();
    }
  }
  Mediuminput(select: MatSelect){
    this.Medium.setValue("");
    if (this.matSelect) {
      this.matSelect.open();
    }
  }
  Groupinput(select: MatSelect){
    this.Group.setValue("");
    if (this.matSelect) {
      this.matSelect.open();
    }
  }
  Orientationinput(select: MatSelect){
    this.Orientation.setValue("");
    if (this.matSelect) {
      this.matSelect.open();
    }
  }
  Trackinput(select: MatSelect){
    this.Track.setValue("");
    if (this.matSelect) {
      this.matSelect.open();
    }
  }
  Streminput(select: MatSelect){
    this.Strem.setValue("");
    if (this.matSelect) {
      this.matSelect.open();
    }
  }
  Substreaminput(select: MatSelect){
    this.Substream.setValue("");
    if (this.matSelect) {
      this.matSelect.open();
    }
  }

}
